import { makeObservable, observable, action, runInAction } from "mobx";
import { GeoService } from "../../../../service/GeoService";
import Geo from "../../../../entities/Geo";
import ServiceName from "../../../../entities/ServiceName";
import { showSuccessToast } from "../../../../hooks/Toastify";

class GeoConfigsTabStore {
    public geos: Geo[] = [];
    public filteredGeoConfigs: Geo[] = [];
    public searchTerm: string = "";
    public isLoading: boolean = false;

    constructor() {
        makeObservable(this, {
            geos: observable,
            filteredGeoConfigs: observable,
            searchTerm: observable,
            isLoading: observable,
            setSearchTerm: action,
            updateMunicipalityService: action,
            loadGeoConfigs: action,
            setLoading: action
        });

        this.loadGeoConfigs();
    }

    setSearchTerm = (term: string) => {
        this.searchTerm = term;
    };

    setLoading = (loading: boolean) => {
        this.isLoading = loading;
    };

    @action
    async updateMunicipalityService(geoId: string, serviceName: ServiceName, enabled: boolean) {
        const geo = this.geos.find(m => m.id === geoId);
        if (geo) {
            if (enabled) {
                // Adicionar serviço se não estiver na lista
                if (!geo.enableServiceNames?.includes(serviceName)) {
                    geo.enableServiceNames?.push(serviceName);
                }
            } else {
                // Remover serviço da lista
                geo.enableServiceNames = geo.enableServiceNames?.filter(
                    (service: ServiceName) => service !== serviceName
                );
            }
            const response = await GeoService.updateEnableServiceNames(geoId, geo.enableServiceNames);
            if (response.success) {
                showSuccessToast(`Actualizado con suceso.`, 4000);
            }
            this.loadGeoConfigs();
        }
        
    };

    @action
    async loadGeoConfigs() {
        // this.setLoading(true);
        const response = await GeoService.search(1, 1000, this.searchTerm, [3]);
        if (response.success && response.data) {
            runInAction(() => {
                this.geos = response.data?.data || [];
                this.filteredGeoConfigs = [...this.geos];
                this.setLoading(false);
            });
        }
    }

    // Método auxiliar para verificar se um serviço está habilitado
    isServiceEnabled = (municipalityId: string, serviceName: ServiceName): boolean => {
        const municipality = this.geos.find(m => m.id === municipalityId);
        return municipality ? (municipality.enableServiceNames?.includes(serviceName) ?? false) : false;
    };
}

export default GeoConfigsTabStore;
